import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAgrupamientoGet = async (credentials, data) => {
  const body = {
    service: "RNHAgrupamientoGet",
    params: {
      rnhAgrupamientoId: data?.id || null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
